import { ref, computed, onMounted, onUnmounted } from "vue";
import util from "../util/index";
export default {
  name: "Clock timer",
  setup() {
    let startTime = ref(Date.now());
    let times = ref(false);
    let clock = ref(null);

    // const clock = computed(() => {
    // times.value = setInterval(() => duration.value++, 1000);
    // clearInterval(times.value)

    //   const hours = Math.floor(duration.value / 3600);
    //   const minutes = Math.floor((duration.value % 3600) / 60);
    //   const seconds = duration.value % 60;

    //   return hours
    //     ? [hours.toString().padStart(2, "0"), minutes.toString().padStart(2, "0"), seconds.toString().padStart(2, "0")].join(":")
    //     : [minutes.toString().padStart(2, "0"), seconds.toString().padStart(2, "0")].join(":");
    // });

    function updateCountdown() {
      const now = Date.now();
      clock.value = util.formatTimeDiff(startTime.value, now);
      if (times.value) {
        console.info("倒计时结束");
        return;
      }
      requestAnimationFrame(updateCountdown);
    }
    onMounted(() => {
      let time = +sessionStorage.getItem("Time");
      if (time) {
        startTime.value = +time;
      }
      updateCountdown();
    });
    onUnmounted(() => times.value = true);
    return {
      clock
    };
  }
};